export class CssCalc {
	static cache = {
		rem: null,
		vw: null,
		vh: null,
	};

	static updateCache() {
		this.cache.rem = this.compute('1rem');
		this.cache.vw  = this.compute('1vw');
		this.cache.vh  = this.compute('1vh');
	}

	static compute(expression) {
		const el = document.createElement('div');
		el.style.position = 'absolute';
		el.style.visibility = 'hidden';
		el.style.width = expression;
		document.body.appendChild(el);
		const value = el.offsetWidth;
		document.body.removeChild(el);
		return value; // immer als Number in px
	}

	static toPx(expression) {
		// Direkter Cache-Zugriff
		if (expression === '1rem') return this.cache.rem ?? this.compute('1rem');
		if (expression === '1vw')  return this.cache.vw  ?? this.compute('1vw');
		if (expression === '1vh')  return this.cache.vh  ?? this.compute('1vh');

		return this.compute(expression);
	}

	static refresh() {
		this.updateCache();
	}
}
